import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15.997",
      cy: "8.001",
      r: "5.333",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.02 28.65c.683.683 1.783.683 3.983.683s3.3 0 3.983-.683.683-1.783.683-3.983 0-3.3-.683-3.984C25.302 20 24.203 20 22.003 20s-3.3 0-3.984.683c-.683.684-.683 1.784-.683 3.984s0 3.3.683 3.983m3.205-4.761h-1.297a.778.778 0 0 0 0 1.555h4.149a.778.778 0 0 0 0-1.555h-2.852",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.124 20.04C23.557 20 22.862 20 21.997 20c-2.2 0-3.3 0-3.983.683-.683.684-.683 1.784-.683 3.983 0 1.555 0 2.56.241 3.258q-.769.076-1.575.076c-5.154 0-9.333-2.388-9.333-5.334s4.179-5.333 9.333-5.333c3.485 0 6.523 1.091 8.127 2.708",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }